import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useActionCounts() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    let cancelled = false;
    const fetchCounts = () =>
      api
        .get("/admin/action-counts")
        .then((res) => !cancelled && setCounts(res.data))
        .catch(() => {});
    fetchCounts();
    const t = setInterval(fetchCounts, 30000);
    const onChanged = () => fetchCounts();
    window.addEventListener("notifications:changed", onChanged);
    return () => {
      cancelled = true;
      clearInterval(t);
      window.removeEventListener("notifications:changed", onChanged);
    };
  }, []);

  return counts;
}
